var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { DifferenceMode } from '../../enum';
import { Outlet } from '../common';
import { PageBody } from '../layout/styled';
import { useReportOutletContext } from './hooks';
import { ReportControl, ScenarioDifferenceToggle } from './resourcing';
export var FinancialLayout = function () {
    var context = useReportOutletContext();
    var _a = useState(DifferenceMode.Absolute), differenceMode = _a[0], setDifferenceMode = _a[1];
    return (_jsxs(PageBody, { children: [_jsx(ReportControl, __assign({ disableDaily: true }, { children: _jsx(ScenarioDifferenceToggle, { differenceMode: differenceMode, setDifferenceMode: setDifferenceMode }) })), _jsx(Outlet, { context: __assign(__assign({}, context), { isPercentages: differenceMode }) })] }));
};
